/* eslint-disable react/button-has-type */
import { Button, Typography } from '@pwskills/rachnaui';
import React, { useEffect, useState } from 'react';
import { IUserPreferences } from '@/interfaces/common';
import LeadFormOptionsApi from '@/api/leadForm';
import { CategoryTypeEnums } from '@/GlobalEnums/enums';
import { ArrowBack } from '@pwskills/rachnaui/Icons';
// import ImageWrapper from '../common/ImageWrapper';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import { domainName } from '@/utils/common/env.constants';
import CircleLoader from './CircleLoader';
// import { useAuthentication } from '../../context/authentication.context';
import ONBOARDING_QUESTIONS from './constants';
// import { IUserPreferences } from '../../interfaces/user';

type Option = {
  title: string;
  slug: string;
  categoryId: string;
};

type OnboardingType = {
  className: string;
  handleSendLeadData: (data: IUserPreferences) => void;
  loading: boolean;
};

const OnboardingForm = ({ className, handleSendLeadData, loading }: OnboardingType) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);
  const [userPreferences, setUserPreferences] = useState<IUserPreferences>({
    background: { title: '', slug: '', categoryId: '' },
    interestedCourse: { title: '', slug: '', categoryId: '' },
    interestedDomain: { title: '', slug: '', categoryId: '' },
  });

  const [studentDomainOptions, setStudentDomainOptions] = useState<{
    'Upskilling Course': Option[];
    'Online Degree': Option[];
  }>({
    'Upskilling Course': [],
    'Online Degree': [],
  });

  useEffect(() => {
    const fetchOnboardinOptionsData = async () => {
      try {
        const [upskillResponse, degreeResponse] = await Promise.all([
          LeadFormOptionsApi.getCourseList({
            categoryType: saasDomains.includes(domainName as domainNameEnums)
              ? CategoryTypeEnums.YCMOU
              : CategoryTypeEnums.SKILLS,
          }),
          LeadFormOptionsApi.getCourseList({
            categoryType: saasDomains.includes(domainName as domainNameEnums)
              ? CategoryTypeEnums.YCMOU
              : CategoryTypeEnums.SKILLS_ONLINE_DEGREE,
          }),
        ]);
        setStudentDomainOptions({
          'Upskilling Course': upskillResponse.data.map((d) => ({
            title: d.title,
            slug: d.slug,
            categoryId: d.categoryId,
          })),
          'Online Degree': degreeResponse.data.map((d) => ({
            title: d.title,
            slug: d.slug,
            categoryId: d.categoryId,
          })),
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching data for', error);
      }
    };
    fetchOnboardinOptionsData();
  }, []);

  const handleOptionClick = async (title: string, slug: string, categoryId: string) => {
    if (currentStep === 0) {
      setUserPreferences((prev) => ({ ...prev, background: { title, slug, categoryId } }));
    } else if (currentStep === 1) {
      setUserPreferences((prev) => ({ ...prev, interestedCourse: { title, slug, categoryId } }));
    } else if (currentStep === 2) {
      setUserPreferences((prev) => ({ ...prev, interestedDomain: { title, slug, categoryId } }));
      handleSendLeadData({ ...userPreferences, interestedDomain: { title, slug, categoryId } });
    }

    if (currentStep < ONBOARDING_QUESTIONS.length - 1) {
      setCurrentStep(currentStep + 1);
      setProgress(progress + 33);
    }
  };

  if (loading) return <CircleLoader />;

  return (
    <div
      className={`relative ${className} bg-gradient-to-b from-[#FAF9F6] to-[#FEFAF9] bg-no-repeat bg-top bg-auto text-white`}
    >
      <div className="relative h-full p-8 gap-8 flex items-center justify-center">
        <div className="absolute w-auto large:top-[20%] overflow-visible opacity-15">
          <img
            src="/images/accountImage/onboardingform/AbstractBG.webp"
            alt="abstract-bg"
            className="w-screen"
          />
        </div>
        <div className="absolute flex items-end flex-grow-0 bottom-0 right-0">
          <img src="/images/accountImage/onboardingform/arrow-top-small.svg" alt="arrow-bg" />
          <img src="/images/accountImage/onboardingform/arrow-top-big.svg" alt="arrow-bg" />
        </div>
        <div className="absolute w-24 h-24 right-0 top-2 medium:top-12">
          <img src="/images/accountImage/onboardingform/arrow-left.webp" alt="arrow-bg" />
        </div>
        <div className="relative h-full bg-[#171214] hidden rounded-3xl shadow-lg medium:min-w-[24%] medium:!block medium:!w-[30%] medium:!max-w-[230px] medium:flex-shrink-0 large:!w-[40%] large:!max-w-[356px] flex-shrink z-50">
          <div
            className="absolute flex w-full h-full bottom-0 left-0"
            style={{
              background: `
              linear-gradient(200deg, rgba(10, 10, 10, 0.65) 22.38%, rgba(233, 120, 98, 0.4) 83.25%),
              linear-gradient(110deg, rgba(10, 10, 10, 0.65) 46.38%, rgb(151 81 138 / 40%) 83.25%)
            `,
              opacity: 0.5,
              backdropFilter: 'blur(80px)',
              borderRadius: '24px',
            }}
          />
          <div className="relative h-full w-full flex flex-col items-start justify-between z-100 px-5 large:!px-4">
            <div className="basis-1/3">
              <img
                src="/images/accountImage/PWSkills-white.png"
                alt="logo"
                className="medium:w-[100px] medium:h-[40px] large:w-[130px] large:h-[50px] cursor-pointer mt-32 large:mt-16"
              />
            </div>
            <div className="flex flex-col gap-3 basis-2/3">
              <p
                className="text-transparent font-nunito text-[18px] leading-[26px] font-semibold text-shadow-custom large:!text-[24px] large:!leading-[36px] large:!font-bold large:!font-inter"
                style={{
                  background: 'linear-gradient(90deg, #FBDB89 22.94%, #FE8F79 72.41%)',
                  backgroundClip: 'text',
                  paddingRight: '48px',
                }}
              >
                Find your solution to upskill and get
              </p>
              <p className="font-inter text-[24px] large:text-[36px] font-bold leading-[36px] large:leading-[60px] text-white [text-shadow:0px_8px_24px_rgba(0_0_0_0.06)]">
                Job-Ready!
              </p>
              <p className="text-white font-nunito text-[14px] font-thin leading-6 large:!text-[16px] large:!leading-6 [text-shadow:0px_8px_24px_rgba(0_0_0_0.06)]">
                Just 15 Seconds to get personalised recommendations to match your interest!
              </p>
            </div>
          </div>
        </div>

        <div className="flex-grow z-50">
          {/* Progress Bar */}
          <div className="flex flex-col justify-center items-center">
            <div className="max-w-[340px] medium:max-w-[472px] flex flex-col justify-center items-start gap-3 px-0 medium:px-9 py-6">
              <div className="w-full flex items-center gap-2 justify-center">
                {ONBOARDING_QUESTIONS.map((question, index) => (
                  <div
                    key={question.id}
                    className={`h-[6px] w-24 large:!w-28 ${index === 0 ? 'rounded-l-lg' : ''} ${
                      index === ONBOARDING_QUESTIONS.length - 1 ? 'rounded-r-lg' : ''
                    } ${index <= currentStep - 1 ? 'bg-[#5CA34B]' : 'bg-[#EAECEF]'}`}
                  />
                ))}
              </div>
              <div className="p-3">
                <Button
                  onClick={() => {
                    if (currentStep > 0) {
                      setCurrentStep(currentStep - 1);
                      setProgress(progress - 33);
                    }
                  }}
                  startIcon={<ArrowBack className="w-4" />}
                  variant="text"
                  className={`!p-0 text-gray-300 hover:text-gray-500 justify-start transition-all ${
                    currentStep === 0 ? 'hidden' : ''
                  }`}
                >
                  Back
                </Button>
              </div>
              <div>
                <Typography variant="bold" component="h3" className="text-[#3D3D3D] px-4">
                  {ONBOARDING_QUESTIONS[currentStep].title}
                  <span className="text-[#D36C75]">*</span>
                </Typography>
              </div>
              <div className="w-full max-w-[334px] h-[300px] flex flex-col gap-3 !text-[#3D3D3D] overflow-y-scroll hide-scrollbar">
                {currentStep === 2 ? (
                  userPreferences?.interestedCourse &&
                  studentDomainOptions[
                    userPreferences.interestedCourse.title as keyof typeof studentDomainOptions
                  ] &&
                  studentDomainOptions[
                    userPreferences.interestedCourse.title as keyof typeof studentDomainOptions
                  ].length > 0 &&
                  studentDomainOptions[
                    userPreferences.interestedCourse.title as keyof typeof studentDomainOptions
                  ].map((option) => (
                    <button
                      key={option.slug}
                      className="w-[100%] p-4 flex items-center justify-start rounded-md bg-[#fff] border border-[#EFEFEF] hover:bg-[#f9f9f9] transition"
                      onClick={() =>
                        handleOptionClick(option.title, option.slug, option.categoryId)
                      }
                    >
                      <p className="font-nunito text-[16px] font-semibold text-[#3D3D3D] leading-6 line-clamp-1">
                        {option.title}
                      </p>
                    </button>
                  ))
                ) : (
                  <div className="flex flex-col gap-3">
                    {ONBOARDING_QUESTIONS[currentStep]?.options?.map((option) => (
                      <button
                        key={`${currentStep}-${option.slug}`}
                        className="w-[100%] p-4 flex items-center justify-start rounded-md bg-[#fff] border border-[#EFEFEF] hover:bg-[#f9f9f9] transition line-clamp-1"
                        onClick={() =>
                          handleOptionClick(option.title, option.slug, option.categoryId)
                        }
                      >
                        <p className="font-nunito text-[16px] font-semibold text-[#3D3D3D] leading-6 line-clamp-1">
                          {option.title}
                        </p>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingForm;
